{
  "action": "操作",
  "allSides": "所有方向",
  "allStatus": "所有状态",
  "amount": "数量",
  "assetsWallet": "资产/钱包",
  "available": "可用",
  "availableBalance": "可用余额",
  "baseCurrency": "基础货币",
  "buy": "买入",
  "buyExalt": "购买 EXALT",
  "buyLong": "买入/做多",
  "buySellTabs": "买入或卖出",
  "buyToken": "购买代币",
  "cancelOrder": "取消订单",
  "cancelOrderFailed": "取消订单失败。",
  "cancelled": "已取消",
  "cancelledOrders": "已取消订单",
  "change24h": "24小时涨跌幅",
  "close": "平仓",
  "completed": "已完成",
  "confirmCancelOrder": "确定要取消该订单吗？",
  "connectWalletFirst": "请先连接钱包。",
  "cost": "花费",
  "deposits": "充值记录",
  "done": "完成",
  "enterAmount": "输入数量",
  "enterPrice": "输入价格",
  "enterValidAmount": "请输入有效的数量。",
  "enterValidPrice": "请输入有效的价格。",
  "exportCsv": "导出 CSV",
  "failed": "失败",
  "filled": "已成交",
  "filledOrders": "已成交订单",
  "filtered": "已筛选",
  "hash": "哈希",
  "high24h": "24小时最高",
  "installWallet": "请安装 MetaMask 或 Trust Wallet。",
  "instruments": "交易品种",
  "insufficientBalance": "余额不足。",
  "lastPrice": "最新价格",
  "limit": "限价",
  "limitOrder": "限价单",
  "limitPrice": "限价",
  "loadingOrders": "订单加载中...",
  "loadingTrades": "成交记录加载中...",
  "loadingTransactions": "交易记录加载中...",
  "low24h": "24小时最低",
  "manageFutures": "管理合约",
  "market": "市价",
  "marketOrder": "市价单",
  "marketOrderNotice": "市价单会立即按当前可用的流动性执行。执行价格可能会有所不同，未成交部分不会保留挂单状态——而是立即取消。",
  "marketPrice": "市场价格",
  "mobileTradingChart": "移动端交易图表",
  "moreOptions": "更多选项",
  "noFilledOrders": "暂无已成交订单。",
  "noOpenOrders": "暂无当前委托。",
  "noOrdersFound": "未找到订单。",
  "noTradeHistory": "暂无成交历史。",
  "noTransactionsFound": "未找到交易记录。",
  "officialExaltContract": "EXALT 官方合约地址",
  "open": "持仓中",
  "openOrders": "当前委托",
  "orderBook": "订单簿",
  "orderCancelledSuccessfully": "订单已成功取消。",
  "orderFailed": "下单失败。",
  "orderHistory": "订单历史",
  "orderIdMissing": "订单编号缺失。",
  "orderPlacedSuccessfully": "订单已成功提交。",
  "orderType": "订单类型",
  "pair": "交易对",
  "pending": "待处理",
  "placeOrder": "下单",
  "placingOrder": "下单中...",
  "positionHistory": "持仓历史",
  "price": "价格",
  "processing": "处理中...",
  "quoteCurrency": "计价货币",
  "recentTrades": "最新成交",
  "searchMarket": "搜索市场...",
  "searchPair": "搜索交易对...",
  "searchPairSideStatus": "搜索交易对、方向或状态...",
  "searchTransactions": "搜索交易记录...",
  "selectPair": "选择交易对",
  "sell": "卖出",
  "sellExalt": "出售 EXALT",
  "sellShort": "卖出/做空",
  "serverError": "服务器错误。",
  "sessionExpired": "会话已过期，请重新登录。",
  "side": "方向",
  "slPrice": "止损价格",
  "spotMarkets": "现货市场",
  "spotTrading": "现货交易",
  "spotTradingSubtitle": "由 Exalt 交易所提供支持的专业现货交易引擎",
  "status": "状态",
  "stopLoss": "止损",
  "swapToExalt": "兑换为 EXALT",
  "takeProfit": "止盈",
  "token": "代币",
  "total": "总额",
  "tpPrice": "止盈价格",
  "tpSl": "止盈/止损",
  "tradFi": "传统金融 / 差价合约",
  "tradFiNoProvider": "尚未连接任何差价合约/传统金融流动性提供商。",
  "tradFiNoProviderDescription": "此模块是提供商就绪的预备架构。一旦连接并验证了真实的经纪商/流动性提供商，外汇、金属、指数、股票和加密货币差价合约品种将显示在此处。",
  "tradFiStatusUnavailable": "目前无法加载传统金融提供商状态。",
  "tradeHistory": "成交历史",
  "trades": "交易记录",
  "tradingViewChart": "TradingView 图表",
  "transactionHistory": "交易记录",
  "volume24h": "24小时成交量",
  "walletConnected": "钱包连接成功。",
  "walletConnectionFailed": "钱包连接失败。",
  "withdrawal": "提现",
  "withdrawals": "提现记录"
}